<template>
	<div class="content flex flex-row">
		<!-- 守护者服务时间 -->
		<div v-if="tabCurrent==2" class="leftTime flex flex-column">
			<div class="leftTime-top flex flex-row">
				<div class="leftTime-top-times flex flex-row">
					<div class="leftTime-top-times-num flex flex-column justify-end" v-for="(item,index) in timeNum"
						:key="index" v-if="timeNum">
						<img src="../../assets/img/douhao.png" alt="" v-if="(item==',')"
							style="width: .08rem;height: .1rem;margin: 0 .1rem;">
						<div v-else>
							<img src="../../assets/img/timeBack.png" alt="" class="leftTime-top-times-num-imgs">
							<div class="leftTime-top-times-num-navs">{{item}}</div>
						</div>
					</div>
					<div class="leftTime-top-times-num flex flex-column justify-end" v-for="(item,index) in timeNum1"
						:key="index" v-if="timeNum1">
						<div>
							<img src="../../assets/img/timeBack.png" alt="" class="leftTime-top-times-num-imgs">
							<div class="leftTime-top-times-num-navs">{{item}}</div>
						</div>
					</div>
				</div>
				<div class="flex flex-column justify-end">截止日期公益总时长(小时)</div>
			</div>
			<div class="leftTime-center flex flex-column">
				<div class="flex flex-row justify-between flex-wrap align-center justify-between">
					<div class="flex flex-column leftTime-center-navs">
						<div class="leftTime-center-navs-titles">守护者</div>
						<input type="text" v-model="form.name" class="leftTime-center-navs-inputs">
					</div>
					<div class="flex flex-column leftTime-center-navs">
						<div class="leftTime-center-navs-titles">时长范围</div>
						<input type="text" v-model="form.maxTime" class="leftTime-center-navs-inputs">
					</div>
					<div class="flex flex-column leftTime-center-navs">
						<div class="leftTime-center-navs-titles">身份证号</div>
						<input type="text" v-model="form.card" class="leftTime-center-navs-inputs">
					</div>
					<div class="flex flex-column leftTime-center-navs">
						<div class="leftTime-center-navs-titles">服务日期</div>
						<div class="flex flex-row align-center justify-between" style="width: 5.52rem;">
							<!-- <el-date-picker v-model="form.startTime" type="date" placeholder="开始时间" :clearable="false"
								class="leftTime-center-navs-dateSelect" @change="selectTime1">
							</el-date-picker> -->
							<el-date-picker v-model="form.startTime" type="datetime" placeholder="开始时间"
								:clearable="true" class="leftTime-center-navs-dateSelect" @change="selectTime1">
							</el-date-picker>
							<div class="leftTime-center-navs-line"></div>
							<!-- <el-date-picker v-model="form.endTime" type="datetime" placeholder="结束时间"
								class="leftTime-center-navs-dateSelect" @change="selectTime2">
							</el-date-picker> -->
							<el-date-picker v-model="form.endTime" type="datetime" placeholder="结束时间" :clearable="true"
								class="leftTime-center-navs-dateSelect" @change="selectTime2">
							</el-date-picker>
						</div>
					</div>
					<div class="flex flex-column leftTime-center-navs">
						<div class="leftTime-center-navs-titles">服务项目</div>
						<input type="text" v-model="form.activityName" class="leftTime-center-navs-inputs">
					</div>
					<div class="leftTime-center-btn flex justify-center" @click="selectList">立即查询</div>
				</div>
			</div>
			<div class="leftTime-bot">
				<el-table :data="tableData" stripe style="width: 100%">
					<el-table-column prop="user_name" label="守护者" width="150">
					</el-table-column>
					<el-table-column prop="activity_start_time" label="服务日期" width="183">
					</el-table-column>
					<el-table-column prop="activity_name" label="服务项目" width="180">
					</el-table-column>
					<el-table-column prop="server_time" label="服务时间(小时)" width="120">
					</el-table-column>
					<el-table-column prop="activity_desc" label="服务内容" width="190">
					</el-table-column>
					<el-table-column label="公益证书" align="center" class-name="small-padding fixed-width">
						<template slot-scope="scope">
							<el-button size="mini" type="text" icon="el-icon-edit" @click="seePic(scope.row)"
								v-hasPermi="['system:children:edit']">查看证书</el-button>
						</template>
					</el-table-column>
				</el-table>
				<!-- 分页 -->
				<div class="flex flex-row align-center leftTime-bot-pages justify-center">
					<p class="leftTime-bot-pages-num">共 {{total}} 条</p>
					<el-pagination background layout="prev, pager, next" :total="total" prev-text="上一页" next-text="下一页"
						@current-change="pagination">
					</el-pagination>
				</div>
			</div>
		</div>

		<!-- 左边部分 -->
		<div class="left flex flex-column" v-else>
			<div class="left-title flex flex-row align-center">
				<div class="left-title-line"></div>
				<div>守护者管理办法</div>
			</div>
			<div class="left-code">
				<img src="../../assets/img/indexBack.jpg" alt="" class="left-code-back">
				<div class="left-code-nav flex flex-row align-center">
					<div class="flex flex-column align-center justify-center" style="">
						<div class="left-code-nav-ewm flex flex-row align-center justify-center">
							<img src="../../assets/img/tab1Current1.png" alt="" class="left-code-nav-ewm-imgs">
						</div>
						<p class="left-code-nav-tet">学生申请表</p>
					</div>
					<!-- style="margin-left: 5.2rem;" -->
					<div class="flex flex-column align-center justify-center" style="">
						<div class="left-code-nav-ewm flex flex-row align-center justify-center">
							<img src="../../assets/img/tab1Current2.png" alt="" class="left-code-nav-ewm-imgs">
						</div>
						<p class="left-code-nav-tet">社会人员申请表</p>
					</div>
				</div>
			</div>
			<div class="left-content">
				<div class="left-content-titles">{{title}}</div>
				<div class="left-content-navs flex flex-column" v-html="content">
				</div>
			</div>
		</div>

		<!-- 右边部分 -->
		<div class="right flex flex-column">
			<div class="right-tops">
				<div class="right-tops-titles">守护者</div>
				<div class="flex flex-column">
					<!-- 守护者报名 -->
					<div :class="[tabCurrent==0?'right-tops-tabActive':'right-tops-tab', 'flex flex-row align-center']"
						@click="tab(0)">
						<div :class="[tabCurrent==0?'right-tops-tabActive-three':'right-tops-tab-three']"></div>
						<div :class="[tabCurrent==0?'right-tops-tabActive-tabTitle':'right-tops-tab-tabTitle']">守护者报名
						</div>
					</div>
					<div class="right-tops-tab1 flex flex-column" v-show="tabCurrent==0">
						<div :class="[tab1Current==index?'right-tops-tab1Active-navs':'right-tops-tab1-navs','flex flex-row align-center']"
							v-for="(item,index) in tab1List" :key="index" @click="tab1(index)">
							<div :class="[tab1Current==index?'right-tops-tab1Active-three':'right-tops-tab1-three']">
							</div>
							<div class="right-tops-tab1-three" v-if="tab1Current!=index"></div>
							<div :class="[tab1Current==index?'right-tops-tab1Active-navs':'right-tops-tab1-navs']">
								{{item}}
							</div>
						</div>
					</div>
					<!-- 活动招募 -->
					<div :class="[tabCurrent==1?'right-tops-tabActive':'right-tops-tab', 'flex flex-row align-center']"
						@click="tab(1)">
						<div :class="[tabCurrent==1?'right-tops-tabActive-three':'right-tops-tab-three']"></div>
						<div :class="[tabCurrent==1?'right-tops-tabActive-tabTitle':'right-tops-tab-tabTitle']">活动招募
						</div>
					</div>
					<div class="right-tops-tab1 flex flex-column" v-show="tabCurrent==1">
						<div :class="[tab2Current==index?'right-tops-tab1Active-navs':'right-tops-tab1-navs','flex flex-row align-center']"
							v-for="(item,index) in tab2List" :key="index" @click="tab2(index)">
							<div :class="[tab2Current==index?'right-tops-tab1Active-three':'right-tops-tab1-three']">
							</div>
							<div class="right-tops-tab1-three" v-if="tab2Current!=index"></div>
							<p :class="[tab2Current==index?'right-tops-tab1Active-navs':'right-tops-tab1-navs']">
								{{item.title}}
							</p>
						</div>
					</div>
					<!-- 志愿服务时间 -->
					<div :class="[tabCurrent==2?'right-tops-tabActive':'right-tops-tab', 'flex flex-row align-center']"
						@click="tab(2)">
						<div :class="[tabCurrent==2?'right-tops-tabActive-three':'right-tops-tab-three']"></div>
						<div :class="[tabCurrent==2?'right-tops-tabActive-tabTitle':'right-tops-tab-tabTitle']">公益服务时长
						</div>
					</div>
				</div>
			</div>
			<div class="right-bots flex flex-column">
				<div class="right-bots-navs flex flex-column align-center justify-center"
					v-if="tab1Current==1||tab1Current==2">
					<img src="../../assets/img/ewm.png" alt="" class="right-bots-navs-imgs">
					<div class="right-bots-navs-texts">-手机填写报名-</div>
				</div>
				<!-- <div class="right-bots-navs flex flex-column align-center justify-center">
					<img src="../../assets/img/ewm.png" alt="" class="right-bots-navs-imgs">
					<div class="right-bots-navs-texts">-扫码签到-</div>
				</div> -->
			</div>
		</div>

		<!-- 查看证书 -->
		<el-dialog title="查看证书" :visible.sync="centerDialogVisible" width="60%" center>
			<div class="flex flex-column justify-center align-center">
				<img :src="zhengshu" alt="" style="width: 100%;height: 100%;">
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import {
		getData,
		getUserServerList,
		lookCert
	} from '../../api/index.js'
	export default {
		data() {
			return {
				tabCurrent: 0,
				// 活动招募
				tab1Current: 0,
				tab1List: ['守护者管理办法', '学生申请表', '社会人员申请表'],
				// 守护者服务时间
				tab2Current: 5,
				tab2List: [{
						id: 0,
						title: '全部'
					}, {
						id: 1,
						title: '未开始'
					},
					{
						id: 2,
						title: '招募中'
					},
					{
						id: 3,
						title: '进行中'
					},
					{
						id: 4,
						title: '已结束'
					}
				],
				timeNum: 0,

				title: '', //方法标题
				content: '', //方法内容

				total: 0,
				form: {
					page: 1,
					limit: 10,
					name: '',
					maxTime: '',
					card: '',
					startTime: '',
					endTime: '',
					activityName: ''
				},

				value1: '',
				value2: '',
				tableData: [],
				zhengshu: '', //证书
				centerDialogVisible: false,
				timeNum1: '',
				timeNum: ''
			};
		},
		created() {
			if (this.$route.query.tabCurrent) {
				this.tabCurrent = Number(this.$route.query.tabCurrent)
			}
			if (this.$route.query.tab1Current) {
				this.tab1Current = Number(this.$route.query.tab1Current)
			}
			this.getDataList()
			this.getUserTime()
			document.title = '守护者时长申请系统'
		},
		methods: {
			//查看证书
			seePic(e) {
				console.log(11, e);
				let data = {
					apply_id: e.id
				}
				
				
				lookCert(data).then(res => {
					console.log('查看证书', res);
					this.zhengshu = res.data.replace("http://zyz.feishuceshi.com", "http://zyz.csapa.ltd");
					this.centerDialogVisible = true
				},error=>{
					console.log(error)
				})
			},
			getUserTime() {
				if (this.form.startTime == null) {
					this.form.startTime = ''
				}
				if (this.form.endTime == null) {
					this.form.endTime = ''
				}
				getUserServerList(this.form).then(res => {
					console.log('志愿服务时长', res);
					this.total = res.count
					this.tableData = res.data
					if (res.serverAllTime < 1000) {
						this.timeNum1 = res.serverAllTime.toString()
						console.log(1, this.timeNum1);
					} else {
						this.timeNum = this.toNum(res.serverAllTime)
						console.log(2, this.timeNum);
					}
				})
			},
			pagination(pages) {
				console.log('页数', pages);
				this.form.page = pages
				this.getUserTime()
			},
			//开始时间
			selectTime1(e) {
				this.form.startTime = this.formatDateTime(e)
				console.log(this.formatDateTime(e));
			},
			// 结束时间
			selectTime2(e) {
				console.log(this.formatDateTime(e));
				this.form.endTime = this.formatDateTime(e)
			},
			toNum(num) {
				var num = (num || 0).toString(),
					result = '';
				while (num.length > 3) {
					result = ',' + num.slice(-3) + result;
					num = num.slice(0, num.length - 3);
				}
				if (num) {
					result = num + result;
				}
				return result;
			},
			// 立即筛选
			selectList() {
				this.form.page = 1
				this.getUserTime()
				// this.form = {
				// 	page: 1,
				// 	limit: 10,
				// 	name:'',
				// 	maxTime:'',
				// 	card:'',
				// 	startTime:'',
				// 	endTime:'',
				// 	activityName:''
				// }
			},
			// 中国标准时间 转换成 年月日
			formatDateTime(date) {
				var y = date.getFullYear();
				var m = date.getMonth() + 1;
				m = m < 10 ? ('0' + m) : m;
				var d = date.getDate();
				d = d < 10 ? ('0' + d) : d;
				var h = date.getHours();
				h = h < 10 ? ('0' + h) : h;
				var minute = date.getMinutes();
				minute = minute < 10 ? ('0' + minute) : minute;
				var second = date.getSeconds()
				second = second < 10 ? ('0' + second) : second;
				// return y + '-' + m + '-' + d+' '+h+':'+minute;
				return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second
			},
			getDataList() {
				getData().then(res => {
					// console.log('守护者管理办法',res);
					this.title = res.title
					this.content = res.content
				},err=>{
					console.log(err)
				})
			},
			tab(index) {
				if (index == 0) {
					if (this.tabCurrent == 0) {
						this.tabCurrent = 5
					} else {
						this.tabCurrent = 0
					}
				} else if (index == 1) {
					if (this.tabCurrent == 1) {
						this.tabCurrent = 5
					} else {
						this.tabCurrent = 1
						this.tab1Current = 0
						this.$router.push({
							path: "/Activity",

						});
					}
				} else if (index == 2) {
					if (this.tabCurrent == 2) {
						this.tabCurrent = 5
					} else {
						this.tabCurrent = 2
						this.tab1Current = 0
					}
				}
			},
			tab1(index) {
				this.tab1Current = index
				// console.log(11,index);
				if (index != 0) {
					this.$router.push({
						path: "/Application",
						query: {
							tab1Current: index,
						}
					});
				}
			},
			tab2(index) {
				this.tab2Current = index
				this.$router.push({
					path: "/Activity",
					query: {
						tab2Current: index,
					}
				});
			}
		},
		mounted() {
			// function toNum(num) {
			// 	var num = (num || 0).toString(),
			// 	result = '';
			// 	while (num.length > 3) {
			// 		result = ',' + num.slice(-3) + result;
			// 		num = num.slice(0, num.length - 3);
			// 	}
			// 	if (num) {
			// 		result = num + result;
			// 	}
			// 	return result;
			// }
			// this.timeNum = toNum(2021459)
		},
	};
</script>
<style>
	html {
		background-color: #F5F6F7;
	}
</style>
<style scoped lang="scss">
	.content {
		width: 100%;
		box-sizing: border-box;
		padding: .6rem 1rem;

		.left {
			width: 75%;
			background-color: #ffffff;
			padding: .37rem .3rem;
			box-sizing: border-box;
			margin-right: .3rem;

			&-title {
				font-size: .26rem;
				font-family: Source Han Sans SC;
				font-weight: bold;
				color: #333333;
				padding-bottom: .18rem;
				border-bottom: .01rem solid #DCDCDC;

				&-line {
					width: .05rem;
					height: .28rem;
					background: #1D602C;
					border-radius: .03rem;
					margin-right: .09rem;
				}
			}

			&-code {
				width: 100%;
				height: 3.15rem;
				position: relative;
				margin-top: .3rem;
				margin-bottom: .65rem;

				&-back {
					width: 100%;
					height: 3.15rem;
				}

				&-nav {
					width: 100%;
					height: 100%;
					// flex: 1;
					padding: 0 .2rem;
					box-sizing: border-box;
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					position: absolute;
					top: 0;
					left: 0;


					&-ewm {
						width: 1.68rem;
						height: 1.68rem;
						background: #FFFFFF;
						// margin: 0 2.8rem;

						&-imgs {
							width: 1.49rem;
							height: 1.49rem;
						}
					}

					&-tet {
						margin-top: .17rem;
						font-size: .16rem;
						font-family: Source Han Sans SC;
						font-weight: bold;
						color: #FEFEFE;
					}
				}
			}

			&-content {
				width: 100%;

				&-titles {
					font-size: .26rem;
					font-family: Source Han Sans SC;
					font-weight: bold;
					color: #333333;
					text-align: center;
					margin-bottom: .25rem;
				}

				&-navs {
					margin-bottom: .3rem;
					font-size: .16rem;
					font-family: Source Han Sans SC;
					font-weight: 300;
					color: #333333;
					line-height: 23px;

					&-titless {
						font-size: .2rem;
						font-family: Source Han Sans SC;
						font-weight: bold;
						color: #333333;
						text-align: center;
						margin-bottom: .1rem;
					}
				}
			}
		}


		.leftTime {
			width: 70%;
			margin-right: .3rem;

			&-top {
				width: 100%;
				background-color: #ffffff;
				margin-bottom: .32rem;
				padding: .48rem .26rem;
				box-sizing: border-box;
				font-size: .2rem;
				font-family: Source Han Sans SC;
				font-weight: 600;
				color: #333333;

				&-times {
					margin-right: .26rem;

					&-num {
						position: relative;

						&-imgs {
							width: .4rem;
							height: .6rem;
							margin-right: .03rem;
						}

						&-navs {
							position: absolute;
							top: 0;
							left: .06rem;
							font-size: .48rem;
							font-family: Comfortaa;
							font-weight: 400;
							color: #FFFFFF;
							text-align: center;
						}
					}
				}
			}

			&-center {
				width: 100%;
				background-color: #ffffff;
				margin-bottom: .32rem;
				padding: .38rem .3rem .46rem .3rem;
				box-sizing: border-box;


				/deep/.el-input__inner {
					border: none;
				}

				/deep/.el-icon-date {}

				/deep/.el-input__icon {
					padding-left: 1.8rem;
					padding-right: 0;
					box-sizing: border-box;
					padding-top: 0.04rem;
				}

				&-navs {
					margin-bottom: .28rem;

					&-titles {
						font-size: .18rem;
						font-family: Source Han Sans SC;
						font-weight: 400;
						color: #333333;
						margin-bottom: .12rem;
					}

					&-inputs {
						width: 2.3rem;
						height: .46rem;
						border: 1px solid #DCDCDC;
						padding-left: .1rem;
					}

					&-dateSelect {
						width: 2.38rem !important;
						height: .48rem !important;
						border: 1px solid #DCDCDC;
						padding-top: .06rem;
						box-sizing: border-box;
					}

					&-line {
						width: .12rem;
						height: .03rem;
						background: #1D602C;
						// margin: 0 .1rem;
					}
				}

				&-btn {
					width: 1.6rem;
					height: .56rem;
					background: #1D602C;
					font-size: .18rem;
					font-family: PingFang SC;
					font-weight: 800;
					color: #FFFFFF;
					line-height: .56rem;
					align-items: center;
				}
			}

			&-bot {

				&-pages {
					width: 100%;
					margin-top: .36rem;

					&-num {
						font-size: .12rem;
						font-family: PingFang SC;
						font-weight: 400;
						color: #333333;
						margin-right: .4rem;
					}

					/deep/.el-pagination {
						height: .3rem;
					}

					/deep/.btn-prev {
						width: .64rem;
						height: .26rem;
						border: .01rem solid #DCDCDC;
						border-radius: .02rem;
						font-size: .12rem;
						font-family: PingFang SC;
						font-weight: 400;
						color: #333333;
						text-align: center;
					}

					/deep/.btn-next {
						width: .64rem;
						height: .26rem;
						border-radius: .02rem;
						font-size: .12rem;
						font-family: PingFang SC;
						font-weight: 400;
						color: #FFFFFF;
						text-align: center;
						background-color: #1D602C;
					}

					/deep/.el-pager li:not(.disabled).active {
						background-color: #1D602C;
					}
				}

				/deep/.el-table .el-table__cell {
					text-align: center;
				}

				/deep/.el-table th.el-table__cell.is-leaf {
					background-color: #1D602C;
					color: #ffffff;
					border: none;
				}

				/deep/.el-table td.el-table__cell,
					{
					color: #333333;
					border: none;
				}

				/deep/.el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
					background-color: #F5F6F7;
				}
			}
		}

		.right {
			width: 25%;
			// flex: 1;
			// position: fixed;
			// top: 0;
			// right: 0;

			&-tops {
				width: 100%;
				background-color: #FFFFFF;

				&-titles {
					width: 100%;
					height: .82rem;
					background: #1D602C;
					line-height: .82rem;
					font-size: .26rem;
					font-family: Source Han Sans SC;
					font-weight: bold;
					color: #FFFFFF;
					text-align: center;
				}

				&-tab {
					width: 100%;
					padding: .3rem .22rem;
					box-sizing: border-box;
					border-top: .01rem solid #DCDCDC;

					&-three {
						border: .1rem solid transparent;
						border-left: .1rem solid #1D602C;
						margin-right: .1rem;
					}

					&-tabTitle {
						font-size: .18rem;
						font-family: Source Han Sans SC;
						font-weight: 400;
						color: #333333;
					}
				}

				&-tabActive {
					width: 100%;
					padding: .3rem .22rem;
					box-sizing: border-box;
					background: #3F6E40;

					&-three {
						border: .1rem solid transparent;
						border-top: .1rem solid #FFFFFF;
						margin-right: .1rem;
						margin-top: .12rem;
					}

					&-tabTitle {
						font-size: .18rem;
						font-family: Source Han Sans SC;
						font-weight: 400;
						color: #ffffff;
					}
				}

				&-tab1 {
					width: 100%;
					padding: .27rem .24rem .17rem;
					box-sizing: border-box;

					&-three {
						width: .12rem;
						background-color: #ffffff;
					}

					&-navs {
						font-size: .16rem;
						font-family: Source Han Sans SC;
						font-weight: 300;
						color: #333333;
						padding-bottom: .1rem;
					}
				}

				&-tab1Active {
					width: 100%;
					padding: .27rem .24rem .17rem;
					box-sizing: border-box;

					&-three {
						border: .06rem solid transparent;
						border-left: .08rem solid #1D602C;
						margin-right: .1rem;
					}

					&-navs {
						font-size: .16rem;
						font-family: Source Han Sans SC;
						font-weight: 400;
						color: #1D602C;
						padding-bottom: .1rem;
					}
				}
			}

			&-bots {
				width: 100%;
				margin-top: .3rem;

				&-navs {
					width: 100%;
					margin-bottom: .3rem;
					background-color: #ffffff;
					padding: .3rem .4rem;
					box-sizing: border-box;

					&-imgs {
						width: 2.17rem;
						height: 2.17rem;
						margin-bottom: .2rem;
					}

					&-texts {
						font-size: .18rem;
						font-family: Source Han Sans SC;
						font-weight: bold;
						color: #333333;
					}
				}
			}
		}
	}

	@media only screen and (max-width: 760px) {
		.content {
			width: 100%;
			padding: 0;

			.left {
				&-code {
					width: 100%;
					height: 2.15rem;

					&-back {
						width: 100%;
						height: 2.15rem;
					}

					&-nav {
						width: 100%;
						height: 100%;
						position: absolute;
						top: 0;
						left: 0;

						&-ewm {
							width: 1.2rem;
							height: 1.2rem;
							background: #FFFFFF;

							&-imgs {
								width: 1rem;
								height: 1rem;
							}
						}

						&-tet {
							// margin-top: .17rem;
							font-size: .16rem;
							font-family: Source Han Sans SC;
							font-weight: bold;
							color: #FEFEFE;
						}
					}
				}

			}

			.right {
				flex: 1;

				&-bots {
					width: 100%;
					margin-top: .3rem;

					&-navs {
						width: 100%;
						background-color: #ffffff;
						padding: .15rem .2rem;
						box-sizing: border-box;
						margin-bottom: .3rem;

						&-imgs {
							width: 1rem;
							height: 1rem;
							margin-bottom: .2rem;
						}

						&-texts {
							font-size: .18rem;
							font-family: Source Han Sans SC;
							font-weight: bold;
							color: #333333;
						}
					}
				}
			}

			.leftTime {
				width: 75%;
				margin-right: .3rem;

				&-center {

					&-navs {

						&-inputs {
							width: 4rem;
						}
					}

				}
			}

		}
	}
</style>
